<template>
<section class="edusources-container main collections-wrapper">
    <div class="center_block">
      <v-row v-if="collections.length" class="collections">
        <v-col v-for="collection in collections" :key="collection.id" cols="12" md="4" sm="6">
          <DynamicCollectionCard :collection="collection" />
        </v-col>
      </v-row>
    </div>
  </section>
</template>

  <script>
  import DynamicCollectionCard from "~/components/Collections/DynamicCollectionCard.vue";

  export default {
    props: {
      collections: {
        type: Array,
        default: null,
      },
    },
    components: {
      DynamicCollectionCard,
    },
  };
  </script>

<style lang="less" scoped>
  @import "./../../variables";

 .collections-wrapper {
    padding-top: 48px;
    padding-bottom: 88px;
   margin: -24px 0;
 }

  .center_block {
    padding: 0;
  }
</style>
